import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';
import { PANEL_DATA } from '../../../../commons/angular/services/panel.service';
import { ToastService } from '../../../../commons/angular/services/toast.service';
import { SettingsActionRecordDisplay } from './settings-action-record.model';

require('./settings-audit-log-detail.component.scss');

@Component({
  standalone: false,
  selector: 'app-settings-audit-log-detail',
  templateUrl: './settings-audit-log-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsAuditLogDetailComponent implements OnInit, OnDestroy {
  @Output() onClose = new EventEmitter<void>();

  public readonly record: SettingsActionRecordDisplay;

  constructor(
    @Inject(PANEL_DATA) public data: { record: SettingsActionRecordDisplay },
    @Inject(OverlayRef) private overlayRef: OverlayRef,
    @Inject(ToastService) private toastService: ToastService
  ) {
    this.record = this.data?.record;
  }

  ngOnInit(): void {
    document.body.classList.add('settings-audit-log-detail-active');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('settings-audit-log-detail-active');
  }

  onCancel(): void {
    this.onClose.emit();
  }

  copyJsonToClipboard(): void {
    const json = JSON.stringify(this.record.rawRecord, null, 2);
    navigator.clipboard.writeText(json)
      .then(() => this.toastService.success('TEXT_COPIED_TO_CLIPBOARD'))
      .catch(() => this.toastService.error('SOMETHING_WENT_WRONG'));
  }
}
